export const SET_ZOOM: String = 'SET_ZOOM';
export const RESET_ZOOM: String = 'RESET_ZOOM';

export interface ZoomData {
    value: number;
}

export interface ZoomAction {
    type: typeof SET_ZOOM;
    payload: ZoomData;
}

export const setZoomAction = (payload: ZoomData): ZoomAction => {
    return {
        type: SET_ZOOM,
        payload,
    };
};

export const ResetZoomAction = () => {
    return {
        type: RESET_ZOOM,
    };
};
